import { getDefaultSdPath, type SdAppRole } from "@sd/lib/sdPaths";
import { useAuth } from "@sd/hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";

type Props = { allowed: SdAppRole[] };

const SDRoleGuard = ({ allowed }: Props) => {
  const { role, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-slate-300 border-t-slate-600" />
      </div>
    );
  }

  if (!role) {
    return <Navigate to="/sd/login" replace state={{ from: location }} />;
  }

  if (!allowed.includes(role)) {
    return <Navigate to={getDefaultSdPath(role)} replace />;
  }

  return <Outlet />;
};

export default SDRoleGuard;
